<section class="table-values-summary-list">
  <h3 class="title-large mb-2">
    Resumo de valores
  </h3>

  <ul class="table-values-summary-list-items">
    <li class="table-values-summary-list-item" *ngIf="displaySubtotal > 0">
      <span>Subtotal</span>
      <span>{{ displaySubtotal | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="displayServiceFeeValue > 0">
      <span>Taxa de serviço</span>
      <span class="text-primary">
        <span *ngIf="serviceFeePercent > 0">(+{{ serviceFeePercent }}%) </span>
        <span>{{ displayServiceFeeValue | currency }}</span>
      </span>
    </li>

    <!-- ACRÉSCIMOS -->
    <li class="table-values-summary-list-item" *ngIf="displayTax > 0">
      <span>Acréscimo</span>
      <span class="text-success">+ {{ displayTax | currency }}</span>
    </li>

    <!-- DESCONTOS -->
    <li class="table-values-summary-list-item" *ngIf="displayManualDiscount > 0">
      <span>Desconto</span>
      <span class="text-warning">- {{ displayManualDiscount | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="table.vouchers && table.vouchers.length > 0 && table.vouchers[0].discountType == 'PERCENTAGE' && displayVoucherDiscount > 0">
      <span>Cupom: {{ table.vouchers[0].voucherName }}</span>
      <span class="text-warning"><span>(-{{ table.vouchers[0].discountValue | number:'1.0-0' }}%)</span> - {{ displayVoucherDiscount | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="table.vouchers && table.vouchers.length > 0 && table.vouchers[0].discountType == 'VALUE'">
      <span>Cupom: {{ table.vouchers[0].voucherName }}</span>
      <span class="text-warning">- {{ table.vouchers[0].discountValue | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="table.fidelity && isLoggedIn && displayFidelityDiscount > 0">
      <span>Fidelidade</span>
      <span class="text-warning">- {{ displayFidelityDiscount | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="showPaymentMethodDiscount && paymentMethodDiscount && paymentMethodDiscountValue > 0">
      <span>Desconto - Forma de pagamento</span>
      <span class="text-warning">
        <span *ngIf="paymentMethodDiscount.type === 'PERCENTAGE'">(-{{ paymentMethodDiscount.value }}%) </span>
        <span>- {{ paymentMethodDiscountValue | currency }}</span>
      </span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="hasCashback && cashbackValue > 0">
      <span>Cashback</span>
      <span class="text-warning">- {{ cashbackValue | currency }}</span>
    </li>

    <li class="table-values-summary-list-item table-values-summary-list-item-total">
      <span>Total</span>
      <span>{{ displayTotal | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="table.paid > 0">
      <span>Pago</span>
      <span>{{ table.paid | currency }}</span>
    </li>
    <li class="table-values-summary-list-item" *ngIf="table.paymentType === 'CUSTOM' && customPaymentValue > 0">
      <span>Vai pagar</span>
      <span>{{ customPaymentValue | currency }}</span>
    </li>
    <li class="table-values-summary-list-item table-values-summary-list-item-highlight" *ngIf="displayRemainingValue > 0 && displayRemainingValue !== displayTotal">
      <span>Restante</span>
      <span>{{ displayRemainingValue | currency }}</span>
    </li>
  </ul>
</section>
